import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import refreshAccessToken from '../utils/refreshAccessToken';
import { SocketProvider } from '../context/SocketContext';

export default function ProtectedRoute({ children, ...rest }) {
  const url = window.location.href;
  const splittedUrl = url.split('.');
  if (splittedUrl.length > 0) {
    const domainWithHTTP = splittedUrl[0];
    const domainSplit = domainWithHTTP.split('//');
    const domain = domainSplit[1];
    if (domain) {
      // const checkOrg = await
    }
  }
  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };
  const validateToken = async () => {
    const token = localStorage.getItem('Token');
    if (token) {
      const decodedJwt = parseJwt(token);
      if (decodedJwt?.exp * 1000 > Date.now()) {
        setIsLoggedIn(true);
        setIsVisible(true)
        return;
      }
    }

    refreshAccessToken().then(() => {
      setIsLoggedIn(true);
      setIsVisible(true)
    }).catch(() => {
      setIsLoggedIn(false);
      setIsVisible(false);
    })
  };
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    validateToken()
  }, []);

  const navigateUnauthenticateUser = () => {
    localStorage.setItem('lastPage', window.location.href);
    localStorage.removeItem('Token');
    window.location.href = '/sign-in';
  };


  if(!isVisible) return null;
  
  if(!isLoggedIn) return navigateUnauthenticateUser();

  return (
    <SocketProvider>
        <Outlet/>
    </SocketProvider>
  );
}
